<script setup lang="ts">
import { DropdownMenuSubContent } from 'reka-ui';

withDefaults(
    defineProps<{
        sideOffset?: number;
    }>(),
    {
        sideOffset: 2,
    },
);
</script>

<template>
    <DropdownMenuSubContent
        :side-offset="sideOffset"
        class="shadow-muval-3 data-[state=closed]:animate-dropdownOut data-[state=open]:animate-dropdownIn z-100 min-w-48 overflow-y-auto rounded-lg border bg-white py-1 outline-hidden"
    >
        <slot />
    </DropdownMenuSubContent>
</template>
